<template>
  <div id="SceneList" class="page scene-list">
    <div class="scene-banner">
      <div class="banner-title">
        专题场景库
      </div>
      <div class="banner-sub-title">
        面向特定主题，跨类别构件检索，成套构件一键载入项目
      </div>
    </div>
    <div class="scene-container">
      <div class="scene-feedback" @click="toFeedback"><span>缺什么专题？告诉我们</span></div>
      <div class="scene-content">
        <div v-for="scene in sceneList" :key="scene.id" class="scene-item">
          <router-link :to="{name:'SceneComponentList', params:{id:scene.id}}">
            <div class="scene-card">
              <div class="scene-thumb">
                <el-image :src="$staticHost(scene.thumbnail)" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="scene-name">{{scene.name}}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import openUrlMixin from '@/mixins/openUrlMixin'
import checkLoginMixin from '@/mixins/checkLoginMixin'

export default {
  name: 'SceneList',
  mixins: [openUrlMixin, checkLoginMixin],
  data() {
    return {
      sceneList: [],
    }
  },
  created() {
    this.getList()
  },
  async beforeRouteLeave(to, from, next) {
    if (to.name === 'SceneComponentList') {
      const isLogin = await this.checkLogin()
      if (isLogin) {
        next()
      } else {
        this.showLoginDialog().catch()
      }
    } else {
      next() // 直接放行
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
    }),
  },
  methods: {
    getList() {
      const query = { software_code: this.softwareCode, software_version: this.softwareVersion }
      this.$api.scene.list(query).then((data) => {
        this.sceneList = data || []
      })
    },
    toFeedback() {
      const ext = this.platform === 'web' ? 'web' : 'G'
      const url = `https://wenjuan.glodon.com/s/L4tFncQH?ext=${ext}`
      this.openUrl(url)
    },
  },
}
</script>

<style lang="less" scoped>
.scene-list{
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F5F5FA;
  .scene-banner{
    text-align: center;
    color: #FFFFFF;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("~@/assets/image/scenes-banner.png") no-repeat center center #2A85B1;
    .banner-title {
      font-size: 2.8rem;
      margin-bottom: 1rem;
    }
    .banner-sub-title {
      font-size: 1.2rem;
    }
  }
  .scene-container{
    width: 1020px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .scene-feedback{
    font-size: 12px;
    color: @theme-color;
    height: 48px;
    line-height: 48px;
    text-align: right;
    cursor: pointer;
    :hover{
      color: @theme-hover-color;
    }
  }
  .scene-content{
    display: grid;
    grid-template-columns: repeat(auto-fill, 242px);
    justify-content: space-between;
    grid-gap: 20px 16px;
  }
  .scene-item{
    box-sizing: border-box;
    border: 1px solid #D2D9E3;
    border-radius: 4px;
    &:hover{
      border: 1px solid @theme-color;
    }
  }
  .scene-card{
    width: 240px;
    height: 168px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    .scene-thumb{
      width: 240px;
      height: 120px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border-radius: 4px 4px 0 0;
    }
    .scene-name{
      position: relative;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #495F70;
      font-size: 1rem;
    }
  }
}
</style>
